import { render, staticRenderFns } from "./RadioLabelPicture.vue?vue&type=template&id=9ac0f1ac"
import script from "./RadioLabelPicture.vue?vue&type=script&lang=js"
export * from "./RadioLabelPicture.vue?vue&type=script&lang=js"
import style0 from "./RadioLabelPicture.vue?vue&type=style&index=0&id=9ac0f1ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports